import React, { useState, useEffect, useContext, useRef, useCallback } from 'react';
import LoadingSpinnerImage from "../Shared/LoadingSpinnerImage.js";
import { downloadEudamedXmlFile, sendEudamedXml, EudamedPlaygroundNotice, describeDownloadWarnings } from "../Shared/EudamedXmlDownload.js";
import '../Shared/Style.css';
import "./App.css";
import { ApplicableRegulation } from "./BasicUdiLists.js";

const ItemDetailsPane = ({ globalContext }) => {

    const AppContext = globalContext;
    const [isSavingItem, setIsSavingItem] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [isShowingSaveMessage, setIsShowingSaveMessage] = useState(false);
    const [visibleDetailsTab, setVisibleDetailsTab] = useState("information");
    const [autoCallOverviewFunction, setAutoCallOverviewFunction] = useState(false);
    const [itemDetailsPaneActive, setItemDetailsPaneActive] = useState(AppContext.isPaneOpen);
    const [itemDetailsPaneOpenEffect, setItemDetailsPaneOpenEffect] = useState(false);
    const [componentKey, setComponentKey] = useState(0);
    const [showItemContextMenu, setShowItemContextMenu] = useState(false);
    const [selectedPDFTab, setSelectedPDFTab] = useState("main");
    const [isUploadingFile, setIsUploadingFile] = useState(false);
    const [isDeletingFile, setIsDeletingFile] = useState(false);
    const [currentLegalManufacturer, setCurrentLegalManufacturer] = useState("");

    const [errorIssuingEntityBasicUDI_DI, setErrorIssuingEntityBasicUDI_DI] = useState(false);
    const [errorBasicUDI_DI_Code, setErrorBasicUDI_DI_Code] = useState(false);
    const [errorLegalManufacturerSRN, setErrorLegalManufacturerSRN] = useState(false);
    const [errorApplicableRegulation, setErrorApplicableRegulation] = useState(false);
    const [errorIsItSystemADeviceInItself, setErrorIsItSystemADeviceInItself] = useState(false);
    const [errorIsItAKit, setErrorIsItAKit] = useState(false);
    const [errorRiskClass, setErrorRiskClass] = useState(false);
    const [errorPresenceOfAnimalTissuesOrCells, setErrorPresenceOfAnimalTissuesOrCells] = useState(false);
    const [errorPresenceOfCellsOrSubstancesOfMicrobialOrigin, setErrorPresenceOfCellsOrSubstancesOfMicrobialOrigin] = useState(false);
    const [errorPresenceOfHumanTissuesOrCells, setErrorPresenceOfHumanTissuesOrCells] = useState(false);
    const [errorActiveDevice, setErrorActiveDevice] = useState(false);
    const [errorDeviceIntendedToAdministerAndOrRemoveMedicinalOroduct, setErrorDeviceIntendedToAdministerAndOrRemoveMedicinalOroduct] = useState(false);
    const [errorImplantable, setErrorImplantable] = useState(false);
    const [errorMeasuringFunction, setErrorMeasuringFunction] = useState(false);
    const [errorReusableSurgicalInstruments, setErrorReusableSurgicalInstruments] = useState(false);
    const [errorCompanionDiagnostic, setErrorCompanionDiagnostic] = useState(false);
    const [errorNearPatientTesting, setErrorNearPatientTesting] = useState(false);
    const [errorPatientSelfTesting, setErrorPatientSelfTesting] = useState(false);
    const [errorPresenceOfSubstanceyMayBeConsideredAMedicinalProductDerivedFromHumanBloodOrPlasma, setErrorPresenceOfSubstanceyMayBeConsideredAMedicinalProductDerivedFromHumanBloodOrPlasma] = useState(false);
    const [errorPresenceOfSubstanceyMayBeConsideredAMedicinalProduct, setErrorPresenceOfSubstanceyMayBeConsideredAMedicinalProduct] = useState(false);
    const [errorReagent, setErrorReagent] = useState(false);
    const [errorProfessionalTesting, setErrorProfessionalTesting] = useState(false);
    const [errorInstrument, setErrorInstrument] = useState(false);
    const [errorDeviceModel, setErrorDeviceModel] = useState(false);
    const [errorDeviceName, setErrorDeviceName] = useState(false);

    const [error, setError] = useState(null);


    const [isGeneratingEudamedXml, setIsGeneratingEudamedXml] = useState(false);
    const [eudamedXmlError, setEudamedXmlError] = useState(null);
    const [eudamedXmlWarning, setEudamedXmlWarning] = useState(null);

    const [showEudamedPopup, setShowEudamedPopup] = useState(false);
    const [selectedEudamedOperation, setSelectedEudamedOperation] = useState("UPDATE");
    const [isLoadingRegisterUdis, setIsLoadingRegisterUdis] = useState(false);
    const [registerUdiList, setRegisterUdiList] = useState([]);
    const [selectedRegisterUdiId, setSelectedRegisterUdiId] = useState("");

    const [isSendingEudamedXml, setIsSendingEudamedXml] = useState(false);
    const [eudamedSendSuccess, setEudamedSendSuccess] = useState(null);
    const eudamedEnabled = window.enableEUDAMED === true;

    const contextMenuButton = useRef(null);
    const contextMenu = useRef(null);


    // Downloads a generated EUDAMED XML for the current Basic UDI-DI - keyed by basicUdiId
    // instead of the selected product ids. Url and filename are captured at click time so the
    // download stays consistent even if the user switches to another Basic UDI-DI while the
    // request is in flight.
    const downloadEudamedXml = (url, filenamePrefix, onSuccess) => {

        const filename = `${filenamePrefix}_${AppContext.currentItem.BasicUDI_DI_Code}.xml`;

        setIsGeneratingEudamedXml(true);
        setEudamedXmlError(null);
        setEudamedXmlWarning(null);

        downloadEudamedXmlFile(url, filename)
            .then((result) => {
                const warning = describeDownloadWarnings(result);
                if (warning)
                    setEudamedXmlWarning(warning);
                if (onSuccess)
                    onSuccess();
            })
            .catch((error) => {
                setEudamedXmlError(error.message);
            })
            .finally(() => {
                setIsGeneratingEudamedXml(false);
            });
    };


    // Loads the UDI-DIs linked to the current Basic UDI-DI, so the user picks which one goes into
    // the DEVICE/POST XML (EUDAMED only accepts one UDI-DI per new Basic UDI-DI). Called whenever
    // the operation dropdown is switched to Register.
    const loadRegisterUdiList = () => {

        setIsLoadingRegisterUdis(true);
        setRegisterUdiList([]);
        setSelectedRegisterUdiId("");
        setEudamedXmlError(null);
        setEudamedXmlWarning(null);

        fetch(AppContext.dataTableStructure.eudamedBasicUdiEUUdisUrl + AppContext.currentItem.Id, { method: "GET" })
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("The UDI-DI list could not be loaded.");
                }
                return response.json();
            })
            .then((list) => {
                setRegisterUdiList(list);
                if (list.length > 0)
                    setSelectedRegisterUdiId(String(list[0].Id));
            })
            .catch((error) => {
                setEudamedXmlError(error.message);
            })
            .finally(() => {
                setIsLoadingRegisterUdis(false);
            });
    };


    // Opens the single EUDAMED popup, defaulting to Update (no UDI-DI list needed for that).
    const openEudamedPopup = () => {
        setSelectedEudamedOperation("UPDATE");
        setEudamedXmlError(null);
        setEudamedXmlWarning(null);
        setEudamedSendSuccess(null);
        setShowEudamedPopup(true);
    };


    const selectEudamedOperation = (operation) => {
        setSelectedEudamedOperation(operation);
        setEudamedXmlError(null);
        setEudamedXmlWarning(null);
        if (operation === "REGISTER")
            loadRegisterUdiList();
    };


    // Generates the XML server-side and submits it straight to EUDAMED (SubmitEudamedXml
    // re-validates the company SRN and the module's security key and rejects with an actionable
    // message when either is missing). Blocked client-side (and server-side) unless the
    // company's enableEUDAMED flag is on.
    const sendToEudamed = (generateUrl, onSuccess) => {

        if (!eudamedEnabled)
            return;

        setIsSendingEudamedXml(true);
        setEudamedXmlError(null);
        setEudamedXmlWarning(null);
        setEudamedSendSuccess(null);

        sendEudamedXml(generateUrl)
            .then(() => {
                setEudamedSendSuccess("Sent to EUDAMED successfully.");
                if (onSuccess)
                    onSuccess();
            })
            .catch((error) => {
                setEudamedXmlError(error.message);
            })
            .finally(() => {
                setIsSendingEudamedXml(false);
            });
    };


    // Both the Download and Send buttons target whichever operation is currently selected -
    // Update always targets the Basic UDI-DI itself; Register targets the chosen UDI-DI.
    const currentEudamedGenerateUrl = () =>
        selectedEudamedOperation === "REGISTER"
            ? AppContext.dataTableStructure.eudamedUploadXmlUrl + AppContext.currentItem.Id + "&euUdiId=" + selectedRegisterUdiId
            : AppContext.dataTableStructure.eudamedUpdateXmlUrl + AppContext.currentItem.Id;

    const downloadCurrentEudamedXml = () => {

        if (selectedEudamedOperation === "REGISTER" && !selectedRegisterUdiId)
            return;

        downloadEudamedXml(
            currentEudamedGenerateUrl(),
            selectedEudamedOperation === "REGISTER" ? "BasicUDI" : "BasicUDIUpdate",
            () => setShowEudamedPopup(false));
    };

    const sendCurrentEudamedXml = () => {

        if (selectedEudamedOperation === "REGISTER" && !selectedRegisterUdiId)
            return;

        sendToEudamed(currentEudamedGenerateUrl(), () => setShowEudamedPopup(false));
    };



    const saveCurrentItem = () => {
        // Validations

        let isValid = true;
    
        setErrorIssuingEntityBasicUDI_DI(false);
        setErrorBasicUDI_DI_Code(false);
        setErrorLegalManufacturerSRN(false);
        setErrorApplicableRegulation(false);
        setErrorIsItSystemADeviceInItself(false);
        setErrorIsItAKit(false);
        setErrorRiskClass(false);
        setErrorPresenceOfAnimalTissuesOrCells(false);
        setErrorPresenceOfCellsOrSubstancesOfMicrobialOrigin(false);
        setErrorPresenceOfHumanTissuesOrCells(false);
        setErrorActiveDevice(false);
        setErrorDeviceIntendedToAdministerAndOrRemoveMedicinalOroduct(false);
        setErrorImplantable(false);
        setErrorMeasuringFunction(false);
        setErrorReusableSurgicalInstruments(false);
        setErrorCompanionDiagnostic(false);
        setErrorNearPatientTesting(false);
        setErrorPatientSelfTesting(false);
        setErrorPresenceOfSubstanceyMayBeConsideredAMedicinalProductDerivedFromHumanBloodOrPlasma(false);
        setErrorPresenceOfSubstanceyMayBeConsideredAMedicinalProduct(false);
        setErrorReagent(false);
        setErrorProfessionalTesting(false);
        setErrorInstrument(false);
        setErrorDeviceModel(false);
        setErrorDeviceName(false);

        setError(null);




        if(AppContext.currentItem.IssuingEntityBasicUDI_DI === "") { setErrorIssuingEntityBasicUDI_DI(true); isValid = false; }
        if(AppContext.currentItem.BasicUDI_DI_Code === "") {setErrorBasicUDI_DI_Code(true); isValid = false;}
        if(AppContext.currentItem.LegalManufacturerSRN === "") {setErrorLegalManufacturerSRN(true); isValid = false;}
        if(AppContext.currentItem.ApplicableRegulation === "") {setErrorApplicableRegulation(true); isValid = false;}
        if(AppContext.currentItem.IsItSystemADeviceInItself === "") {setErrorIsItSystemADeviceInItself(true); isValid = false;}
        if(AppContext.currentItem.IsItAKit === "") {setErrorIsItAKit(true); isValid = false;}
        if(AppContext.currentItem.RiskClass === "") {setErrorRiskClass(true); isValid = false;}
        if(AppContext.currentItem.PresenceOfAnimalTissuesOrCells === "") {setErrorPresenceOfAnimalTissuesOrCells(true); isValid = false;}
        if(AppContext.currentItem.PresenceOfCellsOrSubstancesOfMicrobialOrigin === "") {setErrorPresenceOfCellsOrSubstancesOfMicrobialOrigin(true); isValid = false;}
        if(AppContext.currentItem.PresenceOfHumanTissuesOrCells === "") {setErrorPresenceOfHumanTissuesOrCells(true); isValid = false;}
        if(AppContext.currentItem.ActiveDevice === "") {setErrorActiveDevice(true); isValid = false;}
        if(AppContext.currentItem.DeviceIntendedToAdministerAndOrRemoveMedicinalOroduct === "") {setErrorDeviceIntendedToAdministerAndOrRemoveMedicinalOroduct(true); isValid = false;}
        if(AppContext.currentItem.Implantable === "") {setErrorImplantable(true); isValid = false;}
        if(AppContext.currentItem.MeasuringFunction === "") {setErrorMeasuringFunction(true); isValid = false;}
        if(AppContext.currentItem.ReusableSurgicalInstruments === "") {setErrorReusableSurgicalInstruments(true); isValid = false;}
        if(AppContext.currentItem.CompanionDiagnostic === "") {setErrorCompanionDiagnostic(true); isValid = false;}
        if(AppContext.currentItem.NearPatientTesting === "") {setErrorNearPatientTesting(true); isValid = false;}
        if(AppContext.currentItem.PatientSelfTesting === "") {setErrorPatientSelfTesting(true); isValid = false;}
        if(AppContext.currentItem.PresenceOfSubstanceyMayBeConsideredAMedicinalProductDerivedFromHumanBloodOrPlasma === "") {setErrorPresenceOfSubstanceyMayBeConsideredAMedicinalProductDerivedFromHumanBloodOrPlasma(true); isValid = false;}
        if(AppContext.currentItem.PresenceOfSubstanceyMayBeConsideredAMedicinalProduct === "") {setErrorPresenceOfSubstanceyMayBeConsideredAMedicinalProduct(true); isValid = false;}
        if(AppContext.currentItem.Reagent === "") {setErrorReagent(true); isValid = false;}
        if(AppContext.currentItem.ProfessionalTesting === "") {setErrorProfessionalTesting(true); isValid = false;}
        if(AppContext.currentItem.Instrument === "") {setErrorInstrument(true); isValid = false;}

        if (!(AppContext.currentItem.DeviceModel || "").trim() && !(AppContext.currentItem.DeviceName || "").trim()) {
            setErrorDeviceModel(true);
            setErrorDeviceName(true);
            isValid = false;
        }

        if(!isValid)
            return;




        setIsSavingItem(true);
        setIsShowingSaveMessage(false);
        AppContext.disableAllItemFormFieldsEdit();

        // Update item remotely and if successful...

        let currentItem = AppContext.currentItem;

        let updateItemURL = AppContext.dataUrl;

        let requestOptions = {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(currentItem)
        };

        fetch(updateItemURL, requestOptions)
            .then(async (response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    if (response.status === 400) {
                        let err = await response.text();
                        setError(err);
                    }

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((result) => {

                if (result.Id) {

                    // Update the item in the existing item array
                    const updatedDataArray = AppContext.data.map((item) =>
                        item.Id === result.Id ? result : item
                    );
                    AppContext.setData(updatedDataArray);
                    setIsShowingSaveMessage(true);
                    setIsEditing(false);
                }

            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                console.log("error: " + error);
            })
            .finally(() => {
                setIsSavingItem(false);
            });
    };




    // On parent change of the details pane status "restart" the popup
    useEffect(() => {

        if (AppContext.isPaneOpen == true) {
            // Immediately activate popup, but wait a bit to trigger the open animation
            setItemDetailsPaneActive(true);
            setTimeout(() => { setItemDetailsPaneOpenEffect(true); }, 100);
        }
        else {
            // Immediately do the hide effect but wait 300 to deactivate the popup
            setItemDetailsPaneOpenEffect(false);
            setTimeout(() => { setItemDetailsPaneActive(false); }, 300);
        }

    }, [AppContext.isPaneOpen]);


    const reinitialize = () => {
        setVisibleDetailsTab("information");
        setAutoCallOverviewFunction(false);
        setSelectedPDFTab("main");
        setIsUploadingFile(false);
        setIsDeletingFile(false);
        setIsSavingItem(false);
        setIsEditing(false);
        setIsGeneratingEudamedXml(false);
        setEudamedXmlError(null);
        setShowEudamedPopup(false);
        setSelectedEudamedOperation("UPDATE");
        setRegisterUdiList([]);
        setSelectedRegisterUdiId("");
        setIsSendingEudamedXml(false);
        setEudamedSendSuccess(null);
        AppContext.setIsShowingDeleteConfirmation(false);
    }


    useEffect(() => {

        if (itemDetailsPaneActive)
            reinitialize();

    }, [itemDetailsPaneActive]);


    useEffect(() => {

        if(!itemDetailsPaneOpenEffect)
            setShowItemContextMenu(false);

    }, [itemDetailsPaneOpenEffect])




    const openContextualMenu = () => {
        setShowItemContextMenu(!showItemContextMenu);
    };



    useEffect(() => {
        const handleClickOutside = (e) => {
            if (
                contextMenuButton.current &&
                !contextMenuButton.current.contains(e.target) &&
                contextMenu.current &&
                !contextMenu.current.contains(e.target)
            ) {
                setShowItemContextMenu(false);
                AppContext.setIsShowingDeleteConfirmation(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);







    







    useEffect(() => {

        if (AppContext.isLoadingItemDetails) {

            setIsEditing(false);
        }

    }, [AppContext.isLoadingItemDetails]);


    // Auto-dismiss the "Save successful!" message. The old onTransitionEnd approach broke when
    // the button bar was split into edit/non-edit branches: saving flips isEditing, which
    // remounts the span already in its "shown" class, so no CSS transition (and no
    // onTransitionEnd) ever fires. Flipping the state back shortly after showing lets the
    // save-message-hidden class's delayed fade-out (2s delay + 250ms fade) run as before.
    useEffect(() => {

        if (!isShowingSaveMessage)
            return;

        const timer = setTimeout(() => setIsShowingSaveMessage(false), 100);
        return () => clearTimeout(timer);

    }, [isShowingSaveMessage]);


    // FIELDS

    let IssuingEntityBasicUDI_DI = [
        { value: "GS1", text: "GS1" },
        { value: "HIBCC", text: "HIBCC" },
        { value: "ICCBBA", text: "ICCBBA" },
        { value: "IFA", text: "IFA" },
        { value: "EUDAMED", text: "EUDAMED" },
    ];

    let IsItSystemADeviceInItself = [
        { value: "DEVICE", text: "DEVICE" },
        { value: "PROCEDURE_PACK", text: "PROCEDURE_PACK" },
        { value: "SYSTEM", text: "SYSTEM" },
    ];

    let YesNo = [
        { value: "false", text: "No" },
        { value: "true", text: "Yes" },
    ];

    let SpecialDeviceType = [
        { value: "IVDR_SOFTWARE", text: "Software - IVDR_SOFTWARE" },
        { value: "IVDD_SOFTWARE", text: "Software - IVDD_SOFTWARE" },
        { value: "MDR_SOFTWARE", text: "Software - MDR_SOFTWARE" },
        { value: "MDD_SOFTWARE", text: "Software - MDD_SOFTWARE" },
        { value: "AIMDD_SOFTWARE", text: "Software - AIMDD_SOFTWARE" },
        { value: "MDR_STANDARD_SOFT_CONTACT_LENSES", text: "Standard soft contact lenses - MDR_STANDARD_SOFT_CONTACT_LENSES" },
        { value: "MDD_STANDARD_SOFT_CONTACT_LENSES", text: "Standard soft contact lenses - MDD_STANDARD_SOFT_CONTACT_LENSES" },
        { value: "MDR_RIGID_GAS_PERMEABLE", text: "Rigid Gas Permeable (RGP) Contact Lenses - MDR_RIGID_GAS_PERMEABLE" },
        { value: "MDD_RIGID_GAS_PERMEABLE", text: "Rigid Gas Permeable (RGP) Contact Lenses - MDD_RIGID_GAS_PERMEABLE" },
        { value: "MDR_MADE_TO_ORDER", text: "Made to order soft contact lenses - MDR_MADE_TO_ORDER" },
        { value: "MDD_MADE_TO_ORDER", text: "Made to order soft contact lenses - MDD_MADE_TO_ORDER" },
        { value: "MDR_MADE_TO_ORDER_RIGID_GAS_PERMEABLE", text: "Made to order Rigid Gas Permeable (RGP) contact lenses - MDR_MADE_TO_ORDER_RIGID_GAS_PERMEABLE" },
        { value: "MDR_SPECTACLES_FRAMES", text: "Spectacle frames - MDR_SPECTACLES_FRAMES" },
        { value: "MDD_SPECTACLES_FRAMES", text: "Spectacle frames - MDD_SPECTACLES_FRAMES" },
        { value: "MDR_SPECTACLES_LENSES", text: "Spectacle lenses - MDR_SPECTACLES_LENSES" },
        { value: "MDD_SPECTACLES_LENSES", text: "Spectacle lenses - MDD_SPECTACLES_LENSES" },
        { value: "MDR_READY_MADE_SPECTACLES", text: "Ready-made reading spectacles - MDR_READY_MADE_SPECTACLES" },
        { value: "MDD_READY_MADE_SPECTACLES", text: "Ready-made reading spectacles - MDD_READY_MADE_SPECTACLES" },
        { value: "MDR_ORTHOPEDIC", text: "Orthopaedic - MDR_ORTHOPEDIC" },
        { value: "MDD_ORTHOPEDIC", text: "Orthopaedic - MDD_ORTHOPEDIC" },
        { value: "AIMDD_ORTHOPEDIC", text: "Orthopaedic - AIMDD_ORTHOPEDIC" },
    ];

    let RiskClass = [
        { value: "aimdd", text: "aimdd" },
        { value: "class-a", text: "class-a" },
        { value: "class-b", text: "class-b" },
        { value: "class-c", text: "class-c" },
        { value: "class-d", text: "class-d" },
        { value: "class-i", text: "class-i" },
        { value: "ivd-annex-ii-list-a", text: "ivd-annex-ii-list-a" },
        { value: "class-iia", text: "class-iia" },
        { value: "ivd-annex-ii-list-b", text: "ivd-annex-ii-list-b" },
        { value: "class-iib", text: "class-iib" },
        { value: "ivd-devices-self-testing", text: "ivd-devices-self-testing" },
        { value: "class-iii", text: "class-iii" },
        { value: "ivd-general", text: "ivd-general" },
    ];






    function findValue(array, value) {
        let result = array.find(item => item.value == String(value));

        if (result)
            return result.text;
        return "";
    }




    let hasPdfFile = false;
    let fullWidthPane = false;

    return (
        <>

            {itemDetailsPaneActive ? 
                
                <div
                    style={{ height: "100vh", overflow: "auto" }}
                    className={`${fullWidthPane ? "slide-pane-full-width" : "slide-pane"} ${itemDetailsPaneOpenEffect ? "open" : ""}`}
                >
                    <div className="content" >
                

                        <div style={{ flex: "1" }}>

                            {(AppContext.currentItem === null || AppContext.isLoadingItemDetails) ? (
                                <>
                                    <div>
                                        <LoadingSpinnerImage />
                                    </div>
                                </>
                            ) : (
                                <>
                            


                                    <div style={{display: "flex", flexDirection: "row"}}>

                                
                                        {/* PDF PANE */}
                                        {/* PDF PANE */}
                                        {/* PDF PANE */}

                                        {hasPdfFile ? <>
                                            <div id="pdf-viewer" style={{ flex: 25, paddingRight: "10px", borderRight: "2px solid #f0f0f0", height: "96vh" }}>


                                            </div>

                                        </> : null}





                                        {/* FIELDS PANE */}
                                        {/* FIELDS PANE */}
                                        {/* FIELDS PANE */}

                                        <div id="fields-content" style={{ flex: 20, flexDirection: "column", paddingLeft: "10px", height: "96vh", overflowY: "auto", position: "relative", display: "flex" }}>

                                            <div id="multiple-contents" style={{ flex: 1, overflow: "auto", paddingRight: "15px", display: "flex", flexDirection: "column" }}>
                                        
                                                <div style={{ display: "flex", marginBottom: "10px" }}>

                                                    <div style={{flex: 1, marginRight: "20px"}}>
                                                            <h3>Basic UDI-DI: <span style={{ marginLeft: "14px", fontSize: "18px"}} >{AppContext.currentItem.BasicUDI_DI_Code}</span></h3>
                                                    </div>

                                                    <div style={{marginRight: "5px"} }>
                                                        <button ref={contextMenuButton} className="close-button" onClick={openContextualMenu}>
                                                            <i className="fas fa-ellipsis-v"></i>
                                                        </button>
                                                    </div>

                                                    <div>
                                                        <button className="close-button" onClick={AppContext.closePane}>
                                                            <i className="fas fa-times"></i>
                                                        </button>
                                                    </div>
                                                    
                                                </div>




                                                {/* CONTENT */}
                                                {/* CONTENT */}
                                                {/* CONTENT */}



                                                <div style={{ display: "flex", flexDirection: "column", flex: 1, justifyContent: "start", overflow: "auto" }}>


                                                    {/* INFORMATION FORMS FIELDS */}


                                                        <div style={{height: "100%", overflow: "auto"}}>

                                                            <div style={{ marginBottom: "40px" }}>


                                                                {/* Form field: Issuing Entity Basic UDI-DI */}
                                                                <div className="view-task-field g-mb-0">
                                                                    <div className="view-task-field-line-border">
                                                                        <div className="view-basic-udi-title">Issuing Entity Basic UDI-DI {isEditing ? <>*</> : null}</div>
                                                                        <div className="view-basic-udi-value">
                                                                            {isEditing ?
                                                                            <>
                                                                                <span>
                                                                                    <select style={{maxWidth: "90%"}}
                                                                                        value={AppContext.currentItem.IssuingEntityBasicUDI_DI}
                                                                                        onChange={(e) => {
                                                                                            AppContext.setCurrentItem({
                                                                                                ...AppContext.currentItem,
                                                                                                IssuingEntityBasicUDI_DI: e.target.value
                                                                                            });
                                                                                        }}
                                                                                    >
                                                                                        <option value=""></option>
                                                                                        {IssuingEntityBasicUDI_DI.map((item, index) =>
                                                                                            <option key={index} value={item.value}>{item.text}</option>
                                                                                        )}
                                                                                    </select>
                                                                                </span>
                                                                                {errorIssuingEntityBasicUDI_DI ? <><br/><span className="form-field-error-message">This field is necessary</span></> : null}
                                                                                </>
                                                                            :
                                                                                <span>{findValue(IssuingEntityBasicUDI_DI, AppContext.currentItem.IssuingEntityBasicUDI_DI)}</span>
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                
                                                                {/* Form field: Basic UDI-DI code */}
                                                                <div className="view-task-field g-mb-0">
                                                                    <div className="view-task-field-line-border">
                                                                        <div className="view-basic-udi-title">Basic UDI-DI code {isEditing ? <>*</> : null}</div>
                                                                        <div className="view-basic-udi-value">

                                                                            {isEditing ?
                                                                                <>
                                                                                    <span>
                                                                                        <input
                                                                                            style={{ width: "50%" }}
                                                                                        
                                                                                            onChange={(e) =>
                                                                                                AppContext.setCurrentItem({
                                                                                                    ...AppContext.currentItem,
                                                                                                    BasicUDI_DI_Code: e.target.value
                                                                                                })
                                                                                            }
                                                                                            value={AppContext.currentItem.BasicUDI_DI_Code}
                                                                                        />
                                                                                    </span>
                                                                                    {errorBasicUDI_DI_Code ? <><br/><span className="form-field-error-message">This field is necessary</span></> : null}
                                                                                </>
                                                                                :
                                                                                <span>{AppContext.currentItem.BasicUDI_DI_Code}</span>
                                                                            }

                                                                        </div>
                                                                    </div>
                                                                </div>


                                                                {/* Form field: Legal Manufacturer SRN */}
                                                                <div className="view-task-field g-mb-0">
                                                                    <div className="view-task-field-line-border">
                                                                        <div className="view-basic-udi-title">Legal Manufacturer SRN {isEditing ? <>*</> : null}</div>
                                                                        <div className="view-basic-udi-value">
                                                                            {isEditing ?
                                                                                <>
                                                                                    <span>
                                                                                        <input
                                                                                            style={{ width: "50%" }}
                                                                                        
                                                                                            onChange={(e) =>
                                                                                                AppContext.setCurrentItem({
                                                                                                    ...AppContext.currentItem,
                                                                                                    LegalManufacturerSRN: e.target.value
                                                                                                })
                                                                                            }
                                                                                            value={AppContext.currentItem.LegalManufacturerSRN}
                                                                                        />
                                                                                    </span>
                                                                                    {errorLegalManufacturerSRN ? <><br/><span className="form-field-error-message">This field is necessary</span></> : null}
                                                                                </>
                                                                                :
                                                                                <span>{AppContext.currentItem.LegalManufacturerSRN}</span>
                                                                            }

                                                                        </div>
                                                                    </div>
                                                                </div>



                                                                {/* Form field: Applicable regulation */}
                                                                <div className="view-task-field g-mb-0">
                                                                    <div className="view-task-field-line-border">
                                                                        <div className="view-basic-udi-title">Applicable regulation {isEditing ? <>*</> : null}</div>
                                                                        <div className="view-basic-udi-value">
                                                                            {isEditing ?
                                                                                <>
                                                                                    <div style={{width: "60%"}}>
                                                                                        <select style={{maxWidth: "90%"}}
                                                                                            value={AppContext.currentItem.ApplicableRegulation}
                                                                                            onChange={(e) => {
                                                                                                AppContext.setCurrentItem({
                                                                                                    ...AppContext.currentItem,
                                                                                                    ApplicableRegulation: e.target.value
                                                                                                });
                                                                                            }}
                                                                                        >
                                                                                            <option value=""></option>
                                                                                            {ApplicableRegulation.map((item, index) =>
                                                                                                <option key={index} value={item.value}>{item.text}</option>
                                                                                            )}
                                                                                        </select>
                                                                                        {errorApplicableRegulation ? <><br/><span className="form-field-error-message">This field is necessary</span></> : null}
                                                                                    </div>
                                                                                </>
                                                                                :
                                                                                <span>{findValue(ApplicableRegulation, AppContext.currentItem.ApplicableRegulation)}</span>
                                                                            }

                                                                        </div>
                                                                    </div>
                                                                </div>


                                                                

                                                                {/* Form field: Is it a System which is a Device in itself, Procedure pack which is a Device in itself */}
                                                                <div className="view-task-field g-mb-0">
                                                                    <div className="view-task-field-line-border">
                                                                        <div className="view-basic-udi-title">Is it a System which is a Device in itself, Procedure pack which is a Device in itself {isEditing ? <>*</> : null}</div>
                                                                        <div className="view-basic-udi-value">
                                                                            {isEditing ?
                                                                                <>
                                                                                    <span>
                                                                                        <select style={{maxWidth: "90%"}}
                                                                                            value={AppContext.currentItem.IsItSystemADeviceInItself}
                                                                                            onChange={(e) => {
                                                                                                AppContext.setCurrentItem({
                                                                                                    ...AppContext.currentItem,
                                                                                                    IsItSystemADeviceInItself: e.target.value
                                                                                                });
                                                                                            }}
                                                                                        >
                                                                                            <option value=""></option>
                                                                                            {IsItSystemADeviceInItself.map((item, index) =>
                                                                                                <option key={index} value={item.value}>{item.text}</option>
                                                                                            )}
                                                                                        </select>
                                                                                    </span>
                                                                                    {errorIsItSystemADeviceInItself ? <><br/><span className="form-field-error-message">This field is necessary</span></> : null}
                                                                                </>
                                                                                :
                                                                                <span>{findValue(IsItSystemADeviceInItself, AppContext.currentItem.IsItSystemADeviceInItself)}</span>
                                                                            }

                                                                        </div>
                                                                    </div>
                                                                </div>




                                                                

                                                                {/* Form field: Is it a Kit */}
                                                                <div className="view-task-field g-mb-0">
                                                                    <div className="view-task-field-line-border">
                                                                        <div className="view-basic-udi-title">Is it a Kit {isEditing ? <>*</> : null}</div>
                                                                        <div className="view-basic-udi-value">
                                                                            {isEditing ?
                                                                                <>
                                                                                    <span>
                                                                                        <select style={{maxWidth: "90%"}}
                                                                                            value={AppContext.currentItem.IsItAKit}
                                                                                            onChange={(e) => {
                                                                                                AppContext.setCurrentItem({
                                                                                                    ...AppContext.currentItem,
                                                                                                    IsItAKit: e.target.value
                                                                                                });
                                                                                            }}
                                                                                        >
                                                                                            {YesNo.map((item, index) =>
                                                                                                <option key={index} value={item.value}>{item.text}</option>
                                                                                            )}
                                                                                        </select>
                                                                                    </span>
                                                                                    {errorIsItAKit ? <><br/><span className="form-field-error-message">This field is necessary</span></> : null}
                                                                                </>
                                                                                :
                                                                                <span>{findValue(YesNo, AppContext.currentItem.IsItAKit)}</span>
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </div>



                                                                

                                                                {/* Form field: Special Device Type */}
                                                                <div className="view-task-field g-mb-0">
                                                                    <div className="view-task-field-line-border">
                                                                        <div className="view-basic-udi-title">Special Device Type</div>
                                                                        <div className="view-basic-udi-value">
                                                                        {isEditing ?
                                                                            <>
                                                                                <span>
                                                                                    <select style={{maxWidth: "90%"}}
                                                                                        value={AppContext.currentItem.SpecialDeviceType}
                                                                                        onChange={(e) => {
                                                                                            AppContext.setCurrentItem({
                                                                                                ...AppContext.currentItem,
                                                                                                SpecialDeviceType: e.target.value
                                                                                            });
                                                                                        }}
                                                                                    >
                                                                                        <option value=""></option>
                                                                                        {SpecialDeviceType.map((item, index) =>
                                                                                            <option key={index} value={item.value}>{item.text}</option>
                                                                                        )}
                                                                                    </select>
                                                                                </span>
                                                                            </>
                                                                            :
                                                                            <span>{findValue(SpecialDeviceType, AppContext.currentItem.SpecialDeviceType)}</span>
                                                                        }
                                                                        </div>
                                                                    </div>
                                                                </div>



                                                                

                                                                {/* Form field: Authorised Representative SRN */}
                                                                <div className="view-task-field g-mb-0">
                                                                    <div className="view-task-field-line-border">
                                                                        <div className="view-basic-udi-title">Authorised Representative SRN</div>
                                                                        <div className="view-basic-udi-value">
                                                                        {isEditing ?
                                                                            <>
                                                                                <span>
                                                                                    <input
                                                                                        style={{ width: "50%" }}
                                                                                        
                                                                                        onChange={(e) =>
                                                                                            AppContext.setCurrentItem({
                                                                                                ...AppContext.currentItem,
                                                                                                AuthorisedRepresentative: e.target.value
                                                                                            })
                                                                                        }
                                                                                        value={AppContext.currentItem.AuthorisedRepresentative}
                                                                                    />
                                                                                </span>
                                                                            </>
                                                                            :
                                                                            <span>{AppContext.currentItem.AuthorisedRepresentative}</span>
                                                                        }

                                                                        </div>
                                                                    </div>
                                                                </div>




                                                                

                                                                {/* Form field: Risk Class */}
                                                                <div className="view-task-field g-mb-0">
                                                                    <div className="view-task-field-line-border">
                                                                        <div className="view-basic-udi-title">Risk Class {isEditing ? <>*</> : null}</div>
                                                                        <div className="view-basic-udi-value">
                                                                        {isEditing ?
                                                                            <>
                                                                                <span>
                                                                                    <select style={{maxWidth: "90%"}}
                                                                                        value={AppContext.currentItem.RiskClass}
                                                                                        onChange={(e) => {
                                                                                            AppContext.setCurrentItem({
                                                                                                ...AppContext.currentItem,
                                                                                                RiskClass: e.target.value
                                                                                            });
                                                                                        }}
                                                                                    >
                                                                                        <option value=""></option>
                                                                                        {RiskClass.map((item, index) =>
                                                                                            <option key={index} value={item.value}>{item.text}</option>
                                                                                        )}
                                                                                    </select>
                                                                                </span>
                                                                                {errorRiskClass ? <><br/><span className="form-field-error-message">This field is necessary</span></> : null}
                                                                            </>
                                                                            :
                                                                            <span>{findValue(RiskClass, AppContext.currentItem.RiskClass)}</span>
                                                                        }
                                                                        </div>
                                                                    </div>
                                                                </div>




                                                                

                                                                {/* Form field: Tissues and cells - Presence of animal tissues or Cells, or their derivates */}
                                                                <div className="view-task-field g-mb-0">
                                                                    <div className="view-task-field-line-border">
                                                                        <div className="view-basic-udi-title">Tissues and cells - Presence of animal tissues or Cells, or their derivates {isEditing ? <>*</> : null}</div>
                                                                        <div className="view-basic-udi-value">
                                                                        {isEditing ?
                                                                            <>
                                                                                <span>
                                                                                    <select style={{maxWidth: "90%"}}
                                                                                        value={AppContext.currentItem.PresenceOfAnimalTissuesOrCells}
                                                                                        onChange={(e) => {
                                                                                            AppContext.setCurrentItem({
                                                                                                ...AppContext.currentItem,
                                                                                                PresenceOfAnimalTissuesOrCells: e.target.value
                                                                                            });
                                                                                        }}
                                                                                    >
                                                                                        {YesNo.map((item, index) =>
                                                                                            <option key={index} value={item.value}>{item.text}</option>
                                                                                        )}
                                                                                    </select>
                                                                                </span>
                                                                                {errorPresenceOfAnimalTissuesOrCells ? <><br/><span className="form-field-error-message">This field is necessary</span></> : null}
                                                                            </>
                                                                            :
                                                                            <span>{findValue(YesNo, AppContext.currentItem.PresenceOfAnimalTissuesOrCells)}</span>
                                                                        }
                                                                        </div>
                                                                    </div>
                                                                </div>


                                                                

                                                                {/* Form field: Tissues and cells - Presence of cells or substances of microbial origin */}
                                                                <div className="view-task-field g-mb-0">
                                                                    <div className="view-task-field-line-border">
                                                                        <div className="view-basic-udi-title">Tissues and cells - Presence of cells or substances of microbial origin {isEditing ? <>*</> : null}</div>
                                                                        <div className="view-basic-udi-value">
                                                                        {isEditing ?
                                                                            <>
                                                                                <span>
                                                                                    <select style={{maxWidth: "90%"}}
                                                                                        value={AppContext.currentItem.PresenceOfCellsOrSubstancesOfMicrobialOrigin}
                                                                                        onChange={(e) => {
                                                                                            AppContext.setCurrentItem({
                                                                                                ...AppContext.currentItem,
                                                                                                PresenceOfCellsOrSubstancesOfMicrobialOrigin: e.target.value
                                                                                            });
                                                                                        }}
                                                                                    >
                                                                                        {YesNo.map((item, index) =>
                                                                                            <option key={index} value={item.value}>{item.text}</option>
                                                                                        )}
                                                                                    </select>
                                                                                    {errorPresenceOfCellsOrSubstancesOfMicrobialOrigin ? <><br/><span className="form-field-error-message">This field is necessary</span></> : null}
                                                                                </span>
                                                                            </>
                                                                            :
                                                                            <span>{findValue(YesNo, AppContext.currentItem.PresenceOfCellsOrSubstancesOfMicrobialOrigin)}</span>
                                                                        }
                                                                        </div>
                                                                    </div>
                                                                </div>


                                                                

                                                                {/* Form field: Tissues and cells - presence of human tissues or cells, or their derivates */}
                                                                <div className="view-task-field g-mb-0">
                                                                    <div className="view-task-field-line-border">
                                                                        <div className="view-basic-udi-title">Tissues and cells - presence of human tissues or cells, or their derivates {isEditing ? <>*</> : null}</div>
                                                                        <div className="view-basic-udi-value">
                                                                        {isEditing ?
                                                                            <>
                                                                                <span>
                                                                                    <select style={{maxWidth: "90%"}}
                                                                                        value={AppContext.currentItem.PresenceOfHumanTissuesOrCells}
                                                                                        onChange={(e) => {
                                                                                            AppContext.setCurrentItem({
                                                                                                ...AppContext.currentItem,
                                                                                                PresenceOfHumanTissuesOrCells: e.target.value
                                                                                            });
                                                                                        }}
                                                                                    >
                                                                                        {YesNo.map((item, index) =>
                                                                                            <option key={index} value={item.value}>{item.text}</option>
                                                                                        )}
                                                                                    </select>
                                                                                </span>
                                                                                {errorPresenceOfHumanTissuesOrCells ? <><br/><span className="form-field-error-message">This field is necessary</span></> : null}
                                                                            </>
                                                                            :
                                                                            <span>{findValue(YesNo, AppContext.currentItem.PresenceOfHumanTissuesOrCells)}</span>
                                                                        }
                                                                        </div>
                                                                    </div>
                                                                </div>





                                                                

                                                                {/* Form field: Device Model */}
                                                                <div className="view-task-field g-mb-0">
                                                                    <div className="view-task-field-line-border">
                                                                        <div className="view-basic-udi-title">Device Model</div>
                                                                        <div className="view-basic-udi-value">
                                                                        {isEditing ?
                                                                            <>
                                                                                <span>
                                                                                    <input
                                                                                        style={{ width: "50%" }}
                                                                                        
                                                                                        onChange={(e) =>
                                                                                            AppContext.setCurrentItem({
                                                                                                ...AppContext.currentItem,
                                                                                                DeviceModel: e.target.value
                                                                                            })
                                                                                        }
                                                                                        value={AppContext.currentItem.DeviceModel}
                                                                                    />
                                                                                </span>
                                                                                {errorDeviceModel ? <><br/><span className="form-field-error-message">Device Model or Device Name is required</span></> : null}
                                                                            </>
                                                                            :
                                                                            <span>{AppContext.currentItem.DeviceModel}</span>
                                                                        }
                                                                        </div>
                                                                    </div>
                                                                </div>





                                                                

                                                                {/* Form field: Device Name */}
                                                                <div className="view-task-field g-mb-0">
                                                                    <div className="view-task-field-line-border">
                                                                        <div className="view-basic-udi-title">Device Name</div>
                                                                        <div className="view-basic-udi-value">
                                                                        {isEditing ?
                                                                            <>
                                                                                <span>
                                                                                    <input
                                                                                        style={{ width: "50%" }}
                                                                                        
                                                                                        onChange={(e) =>
                                                                                            AppContext.setCurrentItem({
                                                                                                ...AppContext.currentItem,
                                                                                                DeviceName: e.target.value
                                                                                            })
                                                                                        }
                                                                                        value={AppContext.currentItem.DeviceName}
                                                                                    />
                                                                                </span>
                                                                                {errorDeviceName ? <><br/><span className="form-field-error-message">Device Model or Device Name is required</span></> : null}
                                                                            </>
                                                                            :
                                                                            <span>{AppContext.currentItem.DeviceName}</span>
                                                                        }

                                                                        </div>
                                                                    </div>
                                                                </div>




                                                                

                                                                {/* Form field: Active Device */}
                                                                <div className="view-task-field g-mb-0">
                                                                    <div className="view-task-field-line-border">
                                                                        <div className="view-basic-udi-title">Active Device {isEditing ? <>*</> : null}</div>
                                                                        <div className="view-basic-udi-value">
                                                                        {isEditing ?
                                                                            <>
                                                                                <span>
                                                                                    <select style={{maxWidth: "90%"}}
                                                                                        value={AppContext.currentItem.ActiveDevice}
                                                                                        onChange={(e) => {
                                                                                            AppContext.setCurrentItem({
                                                                                                ...AppContext.currentItem,
                                                                                                ActiveDevice: e.target.value
                                                                                            });
                                                                                        }}
                                                                                    >
                                                                                        {YesNo.map((item, index) =>
                                                                                            <option key={index} value={item.value}>{item.text}</option>
                                                                                        )}
                                                                                    </select>
                                                                                </span>
                                                                                {errorActiveDevice ? <><br/><span className="form-field-error-message">This field is necessary</span></> : null}
                                                                            </>
                                                                            :
                                                                            <span>{findValue(YesNo, AppContext.currentItem.ActiveDevice)}</span>
                                                                        }
                                                                        </div>
                                                                    </div>
                                                                </div>



                                                                

                                                                {/* Form field: Device Intended to administer and/or Remove medicinal product */}
                                                                <div className="view-task-field g-mb-0">
                                                                    <div className="view-task-field-line-border">
                                                                        <div className="view-basic-udi-title">Device Intended to administer and/or Remove medicinal product {isEditing ? <>*</> : null}</div>
                                                                        <div className="view-basic-udi-value">
                                                                        {isEditing ?
                                                                            <>
                                                                                <span>
                                                                                    <select style={{maxWidth: "90%"}}
                                                                                        value={AppContext.currentItem.DeviceIntendedToAdministerAndOrRemoveMedicinalOroduct}
                                                                                        onChange={(e) => {
                                                                                            AppContext.setCurrentItem({
                                                                                                ...AppContext.currentItem,
                                                                                                DeviceIntendedToAdministerAndOrRemoveMedicinalOroduct: e.target.value
                                                                                            });
                                                                                        }}
                                                                                    >
                                                                                        {YesNo.map((item, index) =>
                                                                                            <option key={index} value={item.value}>{item.text}</option>
                                                                                        )}
                                                                                    </select>
                                                                                </span>
                                                                                {errorDeviceIntendedToAdministerAndOrRemoveMedicinalOroduct ? <><br/><span className="form-field-error-message">This field is necessary</span></> : null}
                                                                            </>
                                                                            :
                                                                            <span>{findValue(YesNo, AppContext.currentItem.DeviceIntendedToAdministerAndOrRemoveMedicinalOroduct)}</span>
                                                                        }
                                                                        </div>
                                                                    </div>
                                                                </div>



                                                                

                                                                {/* Form field: Implantable */}
                                                                <div className="view-task-field g-mb-0">
                                                                    <div className="view-task-field-line-border">
                                                                        <div className="view-basic-udi-title">Implantable {isEditing ? <>*</> : null}</div>
                                                                        <div className="view-basic-udi-value">
                                                                        {isEditing ?
                                                                            <>
                                                                                <span>
                                                                                    <select style={{maxWidth: "90%"}}
                                                                                        value={AppContext.currentItem.Implantable}
                                                                                        onChange={(e) => {
                                                                                            AppContext.setCurrentItem({
                                                                                                ...AppContext.currentItem,
                                                                                                Implantable: e.target.value
                                                                                            });
                                                                                        }}
                                                                                    >
                                                                                        {YesNo.map((item, index) =>
                                                                                            <option key={index} value={item.value}>{item.text}</option>
                                                                                        )}
                                                                                    </select>
                                                                                </span>
                                                                                {errorImplantable ? <><br/><span className="form-field-error-message">This field is necessary</span></> : null}
                                                                            </>
                                                                            :
                                                                            <span>{findValue(YesNo, AppContext.currentItem.Implantable)}</span>
                                                                        }
                                                                        </div>
                                                                    </div>
                                                                </div>





                                                                

                                                                {/* Form field: Measuring Function */}
                                                                <div className="view-task-field g-mb-0">
                                                                    <div className="view-task-field-line-border">
                                                                        <div className="view-basic-udi-title">Measuring Function {isEditing ? <>*</> : null}</div>
                                                                        <div className="view-basic-udi-value">
                                                                        {isEditing ?
                                                                            <>
                                                                                <span>
                                                                                    <select style={{maxWidth: "90%"}}
                                                                                        value={AppContext.currentItem.MeasuringFunction}
                                                                                        onChange={(e) => {
                                                                                            AppContext.setCurrentItem({
                                                                                                ...AppContext.currentItem,
                                                                                                MeasuringFunction: e.target.value
                                                                                            });
                                                                                        }}
                                                                                    >
                                                                                        {YesNo.map((item, index) =>
                                                                                            <option key={index} value={item.value}>{item.text}</option>
                                                                                        )}
                                                                                    </select>
                                                                                </span>
                                                                                {errorMeasuringFunction ? <><br/><span className="form-field-error-message">This field is necessary</span></> : null}
                                                                            </>
                                                                            :
                                                                            <span>{findValue(YesNo, AppContext.currentItem.MeasuringFunction)}</span>
                                                                        }
                                                                        </div>
                                                                    </div>
                                                                </div>



                                                                

                                                                {/* Form field: Reusable Surgical Instruments */}
                                                                <div className="view-task-field g-mb-0">
                                                                    <div className="view-task-field-line-border">
                                                                        <div className="view-basic-udi-title">Reusable Surgical Instruments {isEditing ? <>*</> : null}</div>
                                                                        <div className="view-basic-udi-value">
                                                                        {isEditing ?
                                                                            <>
                                                                                <span>
                                                                                    <select style={{maxWidth: "90%"}}
                                                                                        value={AppContext.currentItem.ReusableSurgicalInstruments}
                                                                                        onChange={(e) => {
                                                                                            AppContext.setCurrentItem({
                                                                                                ...AppContext.currentItem,
                                                                                                ReusableSurgicalInstruments: e.target.value
                                                                                            });
                                                                                        }}
                                                                                    >
                                                                                        {YesNo.map((item, index) =>
                                                                                            <option key={index} value={item.value}>{item.text}</option>
                                                                                        )}
                                                                                    </select>
                                                                                </span>
                                                                                {errorReusableSurgicalInstruments ? <><br/><span className="form-field-error-message">This field is necessary</span></> : null}
                                                                            </>
                                                                            :
                                                                            <span>{findValue(YesNo, AppContext.currentItem.ReusableSurgicalInstruments)}</span>
                                                                        }
                                                                        </div>
                                                                    </div>
                                                                </div>



                                                                

                                                                {/* Form field: Companion Diagnostic */}
                                                                <div className="view-task-field g-mb-0">
                                                                    <div className="view-task-field-line-border">
                                                                        <div className="view-basic-udi-title">Companion Diagnostic {isEditing ? <>*</> : null}</div>
                                                                        <div className="view-basic-udi-value">
                                                                        {isEditing ?
                                                                            <>
                                                                                <span>
                                                                                    <select style={{maxWidth: "90%"}}
                                                                                        value={AppContext.currentItem.CompanionDiagnostic}
                                                                                        onChange={(e) => {
                                                                                            AppContext.setCurrentItem({
                                                                                                ...AppContext.currentItem,
                                                                                                CompanionDiagnostic: e.target.value
                                                                                            });
                                                                                        }}
                                                                                    >
                                                                                        {YesNo.map((item, index) =>
                                                                                            <option key={index} value={item.value}>{item.text}</option>
                                                                                        )}
                                                                                    </select>
                                                                                </span>
                                                                                {errorCompanionDiagnostic ? <><br/><span className="form-field-error-message">This field is necessary</span></> : null}
                                                                            </>
                                                                            :
                                                                            <span>{findValue(YesNo, AppContext.currentItem.CompanionDiagnostic)}</span>
                                                                        }
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                


                                                                {/* Form field: Near Patient Testing */}
                                                                <div className="view-task-field g-mb-0">
                                                                    <div className="view-task-field-line-border">
                                                                        <div className="view-basic-udi-title">Near Patient Testing {isEditing ? <>*</> : null}</div>
                                                                        <div className="view-basic-udi-value">
                                                                        {isEditing ?
                                                                            <>
                                                                                <span>
                                                                                    <select style={{maxWidth: "90%"}}
                                                                                        value={AppContext.currentItem.NearPatientTesting}
                                                                                        onChange={(e) => {
                                                                                            AppContext.setCurrentItem({
                                                                                                ...AppContext.currentItem,
                                                                                                NearPatientTesting: e.target.value
                                                                                            });
                                                                                        }}
                                                                                    >
                                                                                        {YesNo.map((item, index) =>
                                                                                            <option key={index} value={item.value}>{item.text}</option>
                                                                                        )}
                                                                                    </select>
                                                                                </span>
                                                                                {errorNearPatientTesting ? <><br/><span className="form-field-error-message">This field is necessary</span></> : null}
                                                                            </>
                                                                            :
                                                                            <span>{findValue(YesNo, AppContext.currentItem.NearPatientTesting)}</span>
                                                                        }
                                                                        </div>
                                                                    </div>
                                                                </div>



                                                                


                                                                {/* Form field: Patient Self Testing */}
                                                                <div className="view-task-field g-mb-0">
                                                                    <div className="view-task-field-line-border">
                                                                        <div className="view-basic-udi-title">Patient Self Testing {isEditing ? <>*</> : null}</div>
                                                                        <div className="view-basic-udi-value">
                                                                        {isEditing ?
                                                                            <>
                                                                                <span>
                                                                                    <select style={{maxWidth: "90%"}}
                                                                                        value={AppContext.currentItem.PatientSelfTesting}
                                                                                        onChange={(e) => {
                                                                                            AppContext.setCurrentItem({
                                                                                                ...AppContext.currentItem,
                                                                                                PatientSelfTesting: e.target.value
                                                                                            });
                                                                                        }}
                                                                                    >
                                                                                        {YesNo.map((item, index) =>
                                                                                            <option key={index} value={item.value}>{item.text}</option>
                                                                                        )}
                                                                                    </select>
                                                                                </span>
                                                                                {errorPatientSelfTesting ? <><br/><span className="form-field-error-message">This field is necessary</span></> : null}
                                                                            </>
                                                                            :
                                                                            <span>{findValue(YesNo, AppContext.currentItem.PatientSelfTesting)}</span>
                                                                        }
                                                                        </div>
                                                                    </div>
                                                                </div>


                                                                


                                                                {/* Form field: Presence of a substance which , if used separately, may be considered to be a medicinal product derived from human blood or plasma */}
                                                                <div className="view-task-field g-mb-0">
                                                                    <div className="view-task-field-line-border">
                                                                        <div className="view-basic-udi-title">Presence of a substance which , if used separately, may be considered to be a medicinal product derived from human blood or plasma {isEditing ? <>*</> : null}</div>
                                                                        <div className="view-basic-udi-value">
                                                                        {isEditing ?
                                                                            <>
                                                                                <span>
                                                                                    <select style={{maxWidth: "90%"}}
                                                                                        value={AppContext.currentItem.PresenceOfSubstanceyMayBeConsideredAMedicinalProductDerivedFromHumanBloodOrPlasma}
                                                                                        onChange={(e) => {
                                                                                            AppContext.setCurrentItem({
                                                                                                ...AppContext.currentItem,
                                                                                                PresenceOfSubstanceyMayBeConsideredAMedicinalProductDerivedFromHumanBloodOrPlasma: e.target.value
                                                                                            });
                                                                                        }}
                                                                                    >
                                                                                        {YesNo.map((item, index) =>
                                                                                            <option key={index} value={item.value}>{item.text}</option>
                                                                                        )}
                                                                                    </select>
                                                                                </span>
                                                                                {errorPresenceOfSubstanceyMayBeConsideredAMedicinalProductDerivedFromHumanBloodOrPlasma ? <><br/><span className="form-field-error-message">This field is necessary</span></> : null}
                                                                            </>
                                                                            :
                                                                            <span>{findValue(YesNo, AppContext.currentItem.PresenceOfSubstanceyMayBeConsideredAMedicinalProductDerivedFromHumanBloodOrPlasma)}</span>
                                                                        }
                                                                        </div>
                                                                    </div>
                                                                </div>



                                                                


                                                                {/* Form field: Presence of substance which, if used separately, may be considered to be a medicinal product */}
                                                                <div className="view-task-field g-mb-0">
                                                                    <div className="view-task-field-line-border">
                                                                        <div className="view-basic-udi-title">Presence of substance which, if used separately, may be considered to be a medicinal product {isEditing ? <>*</> : null}</div>
                                                                        <div className="view-basic-udi-value">
                                                                        {isEditing ?
                                                                            <>
                                                                                <span>
                                                                                    <select style={{maxWidth: "90%"}}
                                                                                        value={AppContext.currentItem.PresenceOfSubstanceyMayBeConsideredAMedicinalProduct}
                                                                                        onChange={(e) => {
                                                                                            AppContext.setCurrentItem({
                                                                                                ...AppContext.currentItem,
                                                                                                PresenceOfSubstanceyMayBeConsideredAMedicinalProduct: e.target.value
                                                                                            });
                                                                                        }}
                                                                                    >
                                                                                        {YesNo.map((item, index) =>
                                                                                            <option key={index} value={item.value}>{item.text}</option>
                                                                                        )}
                                                                                    </select>
                                                                                </span>
                                                                                {errorPresenceOfSubstanceyMayBeConsideredAMedicinalProduct ? <><br/><span className="form-field-error-message">This field is necessary</span></> : null}
                                                                            </>
                                                                            :
                                                                            <span>{findValue(YesNo, AppContext.currentItem.PresenceOfSubstanceyMayBeConsideredAMedicinalProduct)}</span>
                                                                        }
                                                                        </div>
                                                                    </div>
                                                                </div>


                                                                


                                                                {/* Form field: Reagent */}
                                                                <div className="view-task-field g-mb-0">
                                                                    <div className="view-task-field-line-border">
                                                                        <div className="view-basic-udi-title">Reagent {isEditing ? <>*</> : null}</div>
                                                                        <div className="view-basic-udi-value">
                                                                        {isEditing ?
                                                                            <>
                                                                                <span>
                                                                                    <select style={{maxWidth: "90%"}}
                                                                                        value={AppContext.currentItem.Reagent}
                                                                                        onChange={(e) => {
                                                                                            AppContext.setCurrentItem({
                                                                                                ...AppContext.currentItem,
                                                                                                Reagent: e.target.value
                                                                                            });
                                                                                        }}
                                                                                    >
                                                                                        {YesNo.map((item, index) =>
                                                                                            <option key={index} value={item.value}>{item.text}</option>
                                                                                        )}
                                                                                    </select>
                                                                                </span>
                                                                                {errorReagent ? <><br/><span className="form-field-error-message">This field is necessary</span></> : null}
                                                                            </>
                                                                            :
                                                                            <span>{findValue(YesNo, AppContext.currentItem.Reagent)}</span>
                                                                        }
                                                                        </div>
                                                                    </div>
                                                                </div>





                                                                {/* Form field: Professional Testing */}
                                                                <div className="view-task-field g-mb-0">
                                                                    <div className="view-task-field-line-border">
                                                                        <div className="view-basic-udi-title">Professional Testing {isEditing ? <>*</> : null}</div>
                                                                        <div className="view-basic-udi-value">
                                                                        {isEditing ?
                                                                            <>
                                                                                <span>
                                                                                    <select style={{maxWidth: "90%"}}
                                                                                        value={AppContext.currentItem.ProfessionalTesting}
                                                                                        onChange={(e) => {
                                                                                            AppContext.setCurrentItem({
                                                                                                ...AppContext.currentItem,
                                                                                                ProfessionalTesting: e.target.value
                                                                                            });
                                                                                        }}
                                                                                    >
                                                                                        {YesNo.map((item, index) =>
                                                                                            <option key={index} value={item.value}>{item.text}</option>
                                                                                        )}
                                                                                    </select>
                                                                                </span>
                                                                                {errorProfessionalTesting ? <><br/><span className="form-field-error-message">This field is necessary</span></> : null}
                                                                            </>
                                                                            :
                                                                            <span>{findValue(YesNo, AppContext.currentItem.ProfessionalTesting)}</span>
                                                                        }
                                                                        </div>
                                                                    </div>
                                                                </div>





                                                                {/* Form field: Instrument */}
                                                                <div className="view-task-field g-mb-0">
                                                                    <div className="view-task-field-line-border">
                                                                        <div className="view-basic-udi-title">Instrument {isEditing ? <>*</> : null}</div>
                                                                        <div className="view-basic-udi-value">
                                                                        {isEditing ?
                                                                            <>
                                                                                <span>
                                                                                    <select style={{maxWidth: "90%"}}
                                                                                        value={AppContext.currentItem.Instrument}
                                                                                        onChange={(e) => {
                                                                                            AppContext.setCurrentItem({
                                                                                                ...AppContext.currentItem,
                                                                                                Instrument: e.target.value
                                                                                            });
                                                                                        }}
                                                                                    >
                                                                                        {YesNo.map((item, index) =>
                                                                                            <option key={index} value={item.value}>{item.text}</option>
                                                                                        )}
                                                                                    </select>
                                                                                </span>
                                                                                {errorInstrument ? <><br/><span className="form-field-error-message">This field is necessary</span></> : null}
                                                                            </>
                                                                            :
                                                                            <span>{findValue(YesNo, AppContext.currentItem.Instrument)}</span>
                                                                        }
                                                                        </div>
                                                                    </div>
                                                                </div>







                                                                {/* Form field: Is it Device a suture, staple, dental filling, dental brace (...)? */}
                                                                <div className="view-task-field g-mb-0">
                                                                    <div className="view-task-field-line-border">
                                                                        <div className="view-basic-udi-title">Is it Device a suture, staple, dental filling, dental brace (...)?</div>
                                                                        <div className="view-basic-udi-value">
                                                                        {isEditing ?
                                                                            <>
                                                                                <span>
                                                                                    <select style={{maxWidth: "90%"}}
                                                                                        value={AppContext.currentItem.IsItDeviceSutureStapleDentalFilling}
                                                                                        onChange={(e) => {
                                                                                            AppContext.setCurrentItem({
                                                                                                ...AppContext.currentItem,
                                                                                                IsItDeviceSutureStapleDentalFilling: e.target.value
                                                                                            });
                                                                                        }}
                                                                                    >
                                                                                        <option value=""></option>
                                                                                        {YesNo.map((item, index) =>
                                                                                            <option key={index} value={item.value}>{item.text}</option>
                                                                                        )}
                                                                                    </select>
                                                                                </span>
                                                                            </>
                                                                            :
                                                                            <span>{findValue(YesNo, AppContext.currentItem.IsItDeviceSutureStapleDentalFilling)}</span>
                                                                        }
                                                                        </div>
                                                                    </div>
                                                                </div>






























                                                            </div>

                                                        </div>


                                                </div>



                                            </div>



                                            <div id="buttom-bar" style={{ borderTop: "1px solid #f0f0f0" }}>
                                    
                                                {/* FORMS BUTTONS */}

                                                <div className="action-button-bar">

                                                    {AppContext.userRole == "Admin" ? <>

                                                        {isEditing ? <>

                                                            <div className="action-button-bar-left">
                                                                <button
                                                                    className="action-button cancel-button"
                                                                    onClick={AppContext.closePane}
                                                                >
                                                                    Cancel
                                                                </button>
                                                            </div>



                                                            <div className="action-button-bar-center">

                                                                {error ? <>
                                                                    <span style={{color: "#ff603c"}}>Error: {error}</span>
                                                                </> : null}

                                                            </div>



                                                            <div className="action-button-bar-right">
                                                                {!isSavingItem ? (
                                                                    <>
                                                                        <button
                                                                            className="action-button save-button"
                                                                            onClick={saveCurrentItem}
                                                                        >
                                                                            Save
                                                                        </button>
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <LoadingSpinnerImage />
                                                                    </>
                                                                )}
                                                                <span
                                                                    className={`${isShowingSaveMessage
                                                                        ? "save-message-shown"
                                                                        : "save-message-hidden"
                                                                        }`}
                                                                >
                                                                    Save successful!
                                                                </span>

                                                            </div>

                                                        </> : <>

                                                            {/* EUDAMED XML BUTTONS (visible while not editing) */}

                                                            <div className="action-button-bar-left" style={{ display: "flex", alignItems: "center", gap: "10px" }}>

                                                                {!isGeneratingEudamedXml && !isSendingEudamedXml ? (
                                                                    <button
                                                                        className="action-button save-button"
                                                                        style={{ minWidth: "180px", paddingLeft: "20px", paddingRight: "20px" }}
                                                                        onClick={openEudamedPopup}
                                                                    >
                                                                        EUDAMED XML
                                                                    </button>
                                                                ) : (
                                                                    <LoadingSpinnerImage />
                                                                )}

                                                                <span
                                                                    className={`${isShowingSaveMessage
                                                                        ? "save-message-shown"
                                                                        : "save-message-hidden"
                                                                        }`}
                                                                >
                                                                    Save successful!
                                                                </span>


                                                            </div>

                                                        </>}

                                                    </> : null}

                                                </div>


                                            </div>




                                        </div>

                                    </div>


                                </>
                            )}

                        </div>



                    </div>
                </div>
            
            : null}



            




            {showItemContextMenu && (
                <div
                    ref={contextMenu}
                    style={{
                        position: "fixed",
                        top: `50px`,
                        right: `70px`,
                        background: "white",
                        border: "1px solid #ccc",
                        padding: "4px",
                        borderRadius: "10px",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                        zIndex: 1000,
                        borderRadius: "15px",

                    }}
                >

                    {/* DELETE */}
                    {AppContext.userRole === "Admin" ?
                        <>
                            <div className="context-menu-option" onClick={() => { setIsEditing(true); setShowItemContextMenu(false); }}>
                                <i className="fas fa-pencil-alt g-mr-5"></i> Edit
                            </div>
                            {!AppContext.isShowingDeleteConfirmation ? (
                                <div className="context-menu-option" onClick={() => AppContext.setIsShowingDeleteConfirmation(true)}>
                                    <i className="far fa-trash-alt g-mr-5"></i> Delete
                                </div>
                                ) : (
                                    AppContext.isDeletingItem ? (
                                        <LoadingSpinnerImage />
                                    ) : (
                                        <div className="context-menu-option context-delete-option" onClick={AppContext.deleteCurrentItem}>
                                            <i className="far fa-trash-alt g-mr-5"></i> Confirm delete?
                                        </div>
                                    )
                                )
                            }
                        </>
                    : (
                        <>
                            <div className="context-menu-option disabled">
                                <i className="fas fa-pencil-alt g-mr-5"></i> Edit (No Permission)
                            </div>
                            <div className="context-menu-option disabled">
                                <i className="far fa-trash-alt g-mr-5"></i> Delete (No Permission)
                            </div>
                        </>
                    )}


                </div>
            )}



            {/* BASIC UDI-DI EUDAMED POPUP (Register or Update) */}
            {showEudamedPopup && (
                <div style={{ position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", background: "rgba(0,0,0,0.35)", zIndex: 1100, display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <div style={{ background: "white", borderRadius: "15px", boxShadow: "0 2px 8px rgba(0,0,0,0.15)", padding: "25px", width: "480px", maxWidth: "90vw" }}>

                        <div style={{ display: "flex", flexDirection: "row" }}>
                            <div style={{ flex: 1 }}>
                                <h3>Basic UDI-DI on EUDAMED</h3>
                            </div>
                            <div>
                                <button className="close-button" onClick={() => setShowEudamedPopup(false)}>
                                    <i className="fas fa-times"></i>
                                </button>
                            </div>
                        </div>

                        <select className="form-field-text" style={{ width: "100%", marginBottom: "15px" }}
                            value={selectedEudamedOperation}
                            onChange={(e) => selectEudamedOperation(e.target.value)}
                        >
                            <option value="UPDATE">Update Basic UDI-DI</option>
                            <option value="REGISTER">Register Basic UDI-DI (with its first UDI-DI)</option>
                        </select>

                        {selectedEudamedOperation === "UPDATE" ? (
                            <p>
                                Generate or submit the BASIC_UDI/PATCH update for Basic UDI-DI '{AppContext.currentItem.BasicUDI_DI_Code}':
                            </p>
                        ) : isLoadingRegisterUdis ? (
                            <LoadingSpinnerImage />
                        ) : registerUdiList.length === 0 ? (
                            <p>
                                This Basic UDI-DI has no (Master) UDI-DI linked. EUDAMED requires a new Basic UDI-DI
                                to be registered together with one (Master) UDI-DI - link a product/UDI-DI to it first.
                            </p>
                        ) : (
                            <>
                                <p>
                                    EUDAMED only accepts one (Master) UDI-DI per new Basic UDI-DI. Select which UDI-DI
                                    to register together with Basic UDI-DI '{AppContext.currentItem.BasicUDI_DI_Code}':
                                </p>
                                <select className="form-field-text" style={{ width: "100%" }}
                                    value={selectedRegisterUdiId}
                                    onChange={(e) => setSelectedRegisterUdiId(e.target.value)}
                                >
                                    {registerUdiList.map((udi) => (
                                        <option key={udi.Id} value={udi.Id}>
                                            {udi.ProductCode ? `${udi.ProductCode} - ${udi.Code}` : udi.Code}
                                        </option>
                                    ))}
                                </select>
                            </>
                        )}

                        {eudamedXmlError ? <><br /><span className="form-field-error-message" style={{ whiteSpace: "pre-line" }}>{eudamedXmlError}</span></> : null}
                        {eudamedXmlWarning ? <><br /><span style={{ whiteSpace: "pre-line", color: "#6c757d" }}>Warning: {eudamedXmlWarning}</span></> : null}

                        <EudamedPlaygroundNotice />

                        <div style={{ marginTop: "20px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>

                            <div style={{ display: "flex", gap: "10px" }}>
                                {isGeneratingEudamedXml || isSendingEudamedXml ? (
                                    <LoadingSpinnerImage />
                                ) : selectedEudamedOperation === "UPDATE" || registerUdiList.length > 0 ? (
                                    <>
                                        <button
                                            className="action-button save-button"
                                            onClick={downloadCurrentEudamedXml}
                                        >
                                            Download XML
                                        </button>

                                        <button
                                            className="action-button save-button"
                                            disabled={!eudamedEnabled}
                                            title={eudamedEnabled ? "Submit this directly to EUDAMED" : "EUDAMED submission is not enabled for your company"}
                                            style={eudamedEnabled ? {} : { opacity: 0.5, cursor: "not-allowed" }}
                                            onClick={sendCurrentEudamedXml}
                                        >
                                            Send to EUDAMED
                                        </button>
                                    </>
                                ) : null}
                            </div>

                            <button
                                className="action-button cancel-button"
                                onClick={() => setShowEudamedPopup(false)}
                            >
                                Cancel
                            </button>

                        </div>

                    </div>
                </div>
            )}
















        </>
    );
};














export default ItemDetailsPane;